export default __webpack_public_path__ + "static/media/gift-card.7889baba.svg";